"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Icon = _interopRequireWildcard(require("./icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var components = [{
  name: '媒体组件',
  key: 'media',
  data: [{
    name: '轮播图',
    type: 'banner',
    icon: Icon.banner
  }, {
    name: '图片',
    type: 'image',
    icon: Icon.image
  }, {
    name: '图片橱窗',
    type: 'window',
    icon: Icon.window
  }, {
    name: '视频',
    type: 'video',
    icon: Icon.video
  }, {
    name: '文章',
    type: 'article',
    icon: Icon.article
  }]
}, {
  name: '商城组件',
  key: 'store',
  data: [{
    name: '搜索框',
    type: 'search',
    icon: Icon.search
  }, {
    name: '店铺公告',
    type: 'notice',
    icon: Icon.notice
  }, {
    name: '导航',
    type: 'navBar',
    icon: Icon.navBar
  }, {
    name: '商品',
    type: 'goods',
    icon: Icon.goods
  }, {
    name: '在线客服',
    type: 'service',
    icon: Icon.service
  }]
}, {
  name: '其他组件',
  key: 'other',
  data: [{
    name: '富文本',
    type: 'richText',
    icon: Icon.richText
  }, {
    name: '辅助空白',
    type: 'blank',
    icon: Icon.blank
  }, {
    name: '辅助线',
    type: 'guide',
    icon: Icon.guide
  }]
}, {
  name: '单页组件',
  key: 'single',
  data: [{
    name: 'tab列表页',
    type: 'tabList',
    icon: Icon.richText
  }, {
    name: '吸顶tab列表页',
    type: 'stickyTabList',
    icon: Icon.richText
  }]
}];
var _default = exports.default = {
  data: function data() {
    return {
      Icon: Icon,
      components: components
    };
  },
  computed: {
    componentKeys: function componentKeys() {
      var components = this.components;
      return components.map(function (item) {
        return item.key;
      });
    }
  },
  methods: {
    handleDragStart: function handleDragStart(event, type) {
      if (!event || !event.dataTransfer) return;
      event.dataTransfer.effectAllowed = 'copy';
      event.dataTransfer.setData('text/plain', type);
      this.$emit('startDragItem', type);
    },
    handleDragEnd: function handleDragEnd() {
      this.$emit('endDragItem');
    },
    handleClickItem: function handleClickItem(type) {
      this.$emit('handleClickItem', type);
    }
  }
};